import React from 'react';
import InboxMessage from '../../InboxMessage/InboxMessage';

const InboxFeedItem = ({ message, currentUser }) => {
  const isOwnMessage =
    message.sender &&
    message.sender.id &&
    currentUser &&
    currentUser.id &&
    message.sender.id.uuid === currentUser.id.uuid;

  return (
    <InboxMessage
      user={message.sender}
      date={message.attributes.createdAt}
      source={message.source}
      direction={isOwnMessage ? 'right' : 'left'}
    >
      {message.attributes.content}
    </InboxMessage>
  );
};

export default InboxFeedItem;
